import { XMarkIcon } from "@heroicons/react/24/outline";
import { Formik, Form, Field } from "formik";

export default function ExportReportsOffcanvas({ notesExport, onClose }) {
    return (
        <>
            {/* Overlay */}
            {notesExport && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-40 z-40"
                    onClick={onClose}
                ></div>
            )}

            {/* Offcanvas Panel */}
            <div
                className={`fixed inset-y-0 right-0 w-full max-w-[650px] bg-white shadow-xl transform transition-transform duration-300 z-50 ${notesExport ? "translate-x-0" : "translate-x-full"
                    }`}
            >
                {/* Header */}
                <div className="flex justify-between items-center p-6 border-b">
                    <h2 className="text-[22px] font-bold text-[#283C50]">
                        Export Reports
                    </h2>
                    <button
                        onClick={onClose}
                        className="text-gray-500 hover:text-gray-800"
                    >
                        <XMarkIcon className="h-6 w-6" />
                    </button>
                </div>

                {/* Formik Form */}
                <Formik
                    initialValues={{
                        classGroup: "",
                        student: "",
                        application: "",
                        dateFrom: "",
                        dateTo: "",
                        reportTypes: [],
                        fileFormats: [],
                    }}
                    onSubmit={(values) => {
                        console.log("Form Data:", values);
                        alert("Form submitted! Check console for data.");
                    }}
                >
                    {({ values }) => (
                        <Form className="p-6 space-y-6 overflow-y-auto h-[calc(100%-4rem)]">
                            {/* Class Selector */}
                            {/* Class / Group Selector */}
                            <div>
                                <label className="block text-md font-medium text-secondary-700">
                                    Class / Group Selector
                                </label>
                                <div className="relative mt-1">
                                    <Field
                                        as="select"
                                        name="classGroup"
                                        className="w-full border rounded-lg px-3 py-4 pr-10 focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none"
                                    >
                                        <option value="">Select</option>
                                        <option value="classA">Class A</option>
                                        <option value="classB">Class B</option>
                                    </Field>
                                    <span className="absolute inset-y-0 right-3 flex items-center pointer-events-none">
                                        <svg
                                            width="20"
                                            height="20"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path d="M12 18L2 7H22L12 18Z" fill="black" />
                                        </svg>
                                    </span>
                                </div>
                            </div>

                            {/* Student Selector */}
                            <div>
                                <label className="block text-md font-medium text-secondary-700">
                                    Student Selector
                                </label>
                                <div className="relative mt-1">
                                    <Field
                                        as="select"
                                        name="student"
                                        className="w-full border rounded-lg px-3 py-4 pr-10 focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none"
                                    >
                                        <option value="">Select</option>
                                        <option value="student1">Michel Shen</option>
                                        <option value="student2">John Doe</option>
                                    </Field>
                                    <span className="absolute inset-y-0 right-3 flex items-center pointer-events-none">
                                        <svg
                                            width="20"
                                            height="20"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path d="M12 18L2 7H22L12 18Z" fill="black" />
                                        </svg>
                                    </span>
                                </div>
                            </div>

                            {/* Application */}
                            <div>
                                <label className="block text-md font-medium text-secondary-700">
                                    Application
                                </label>
                                <div className="relative mt-1">
                                    <Field
                                        as="select"
                                        name="application"
                                        className="w-full border rounded-lg px-3 py-4 pr-10 focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none"
                                    >
                                        <option value="">Select</option>
                                        <option value="mathApp">Math App</option>
                                        <option value="scienceApp">Science App</option>
                                    </Field>
                                    <span className="absolute inset-y-0 right-3 flex items-center pointer-events-none">
                                        <svg
                                            width="20"
                                            height="20"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path d="M12 18L2 7H22L12 18Z" fill="black" />
                                        </svg>
                                    </span>
                                </div>
                            </div>


                            {/* Date Range */}
                            <div>
                                <label className="block text-md font-medium text-secondary-700">
                                    Date Range
                                </label>
                                <div className="flex space-x-2 mt-1">
                                    <Field
                                        type="date"
                                        name="dateFrom"
                                        className="w-1/2 border rounded-lg px-3 py-4 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    />
                                    <Field
                                        type="date"
                                        name="dateTo"
                                        className="w-1/2 border rounded-lg px-3 py-4 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    />
                                </div>
                            </div>

                            {/* Report Type */}
                            <div className="border rounded-[16px] p-4">
                                <p className="text-sm font-medium text-gray-700 mb-2">Report Type</p>
                                <div className="space-y-2">
                                    {[
                                        {
                                            title: "Performance Summary",
                                            desc: "Grades, progress trends, badges",
                                            titleColor: "text-[#283C50]",
                                            descColor: "text-secondary-800",
                                        },
                                        {
                                            title: "Usage Statistics",
                                            desc: "Time spent, sessions, app usage",
                                            titleColor: "text-[#283C50]",
                                            descColor: "text-secondary-800",
                                        },
                                        {
                                            title: "Notes & Grades Log",
                                            desc: "Linked educator notes, remarks, grades",
                                            titleColor: "text-[#283C50]",
                                            descColor: "text-secondary-800",
                                        },
                                        {
                                            title: "Full Report (All Data)",
                                            desc: "Comprehensive export",
                                            titleColor: "text-[#283C50]",
                                            descColor: "text-secondary-800",
                                        },
                                    ].map(({ title, desc, titleColor, descColor }, idx) => (
                                        <label
                                            key={idx}
                                            className="flex items-start py-1 space-x-2 text-[15px] cursor-pointer"
                                        >
                                            <Field
                                                type="checkbox"
                                                name="reportTypes"
                                                value={title}
                                                className="mt-1 w-5 h-5"
                                            />
                                            <span>
                                                <span className={`${titleColor} font-medium`}>{title}</span>
                                                <span className={`ml-1 ${descColor}`}>→ {desc}</span>
                                            </span>
                                        </label>
                                    ))}
                                </div>
                            </div>

                            {/* File Format Selection */}
                            <div className="border rounded-[16px] p-4">
                                <p className="text-sm font-medium text-secondary-700 mb-2">
                                    File Format Selection
                                </p>
                                <div className="space-y-2">
                                    {[
                                        "PDF (formatted for presentation)",
                                        "CSV (raw data for analysis)",
                                    ].map((label, idx) => (
                                        <label
                                            key={idx}
                                            className="flex items-start space-x-2 text-[15px] text-secondary-900"
                                        >
                                            <Field
                                                type="checkbox"
                                                name="fileFormats"
                                                value={label}
                                                className="mt-1 mr-3 w-5 h-5"
                                            />
                                            {label}
                                        </label>
                                    ))}
                                </div>
                            </div>

                            {/* Footer Buttons */}
                            <div className="mt-6 flex space-x-3">
                                <button
                                    type="button"
                                    className="flex-1 border border-primary-500 text-primary-600 font-medium py-4 px-4 rounded-lg hover:bg-primary-50"
                                >
                                    Save as Template
                                </button>
                                <button
                                    type="submit"
                                    className="flex-1 bg-primary-600 text-white font-medium py-4 px-4 rounded-lg hover:bg-primary-700"
                                >
                                    Generate & Download
                                </button>
                                <button
                                    type="button"
                                    className="bg-gray-900 p-2 rounded-lg hover:bg-gray-800 py-4 px-4"
                                >
                                    🖨️
                                </button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </>
    );
}
